export class BookingDetail {
    id: number;
    createdAt: string;
    balance: number;
    semester: Semester;
    student: Student;
    classes: Classes[];
    transactions: Transactions[];
}
class Semester {
    id: number;
    name: string;
    schoolYearId: number
}
class Classes {
    classId: number;
    active: boolean;
    startDate: string;
    sessionCount: number;
    costAmount: number;
    paidAmount: number;
}
export class Transactions {
    createAt: string;
    action:any;
    amount: number;
    type: any;
    method: string;
    note: string;
}
class Student {
    id: number;
    aisId: number;
    familyName: string;
    givenName: string;
    homeroom: {
      id: number;
      name: string;
      campusId: number;
      yearLevelId: number;
    }
}


// WEBPACK FOOTER //
// ./src/holiday/models/BookingDetail.ts